import React from 'react'

export default props => (
  <svg viewBox="0 0 22 14" {...props}>
    <path d="M15.0050083,6 C16.6677796,6 18,4.66 18,3 C18,1.34 16.6677796,0 15.0050083,0 C13.3422371,0 12,1.34 12,3 C12,4.66 13.3422371,6 15.0050083,6 Z M7.00500835,6 C8.66777963,6 10,4.66 10,3 C10,1.34 8.66777963,0 7.00500835,0 C5.34223706,0 4,1.34 4,3 C4,4.66 5.34223706,6 7.00500835,6 Z M7,8 C4.67,8 0,9.17 0,11.5 L0,14 L14,14 L14,11.5 C14,9.17 9.33,8 7,8 Z M14.9736512,8 C14.6825596,8 14.3513174,8.02 14,8.05 C15.1643664,8.89 15.9774153,10.02 15.9774153,11.5 L15.9774153,14 L22,14 L22,11.5 C22,9.17 17.3124216,8 14.9736512,8 Z" />
  </svg>
)



// WEBPACK FOOTER //
// ./src/Assets/Images/icons/clients.js